import Typography from './Typography';
import * as TypographyMappings from './configurations';
export * from './configurations';
export * from './legacyStyles';
export * from './utils';
export * from './Typography';
export { TypographyMappings };
export * from './types';
export * from './enum';
export default Typography;
//# sourceMappingURL=index.js.map